/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useRegionsList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const RegionSelect = React.forwardRef(({ placeholder = 'Type to search region', children, ...props }, ref) => (
  <SearchableEntitySelect ref={ref} placeholder={placeholder} useList={useRegionsList} {...props} />
));

export default RegionSelect;
